import { ProjectType } from '@/api/common-types'
import type { WorkItem } from '@/modules/project/api/work-item'

/** Split project detail work items into display sections by item_type. */
export function partitionWorkItemsByType(items: WorkItem[]) {
  return {
    lesson: items.filter((item) => item.item_type === ProjectType.LESSON),
    video: items.filter((item) => item.item_type === ProjectType.VIDEO),
    document: items.filter((item) => item.item_type === ProjectType.DOCUMENT),
  }
}

export function hasWorkItemSections(items: WorkItem[]): boolean {
  const { lesson, video, document } = partitionWorkItemsByType(items)
  return lesson.length > 0 || video.length > 0 || document.length > 0
}
